(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/middleware-competition/assets/competition.js') >= 0) return;  svs.modules.push('/components/payment/middleware-competition/assets/competition.js');


'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$components$payme = svs.components.payment.common,
  logger = _svs$components$payme.logger,
  constants = _svs$components$payme.constants;
const analytics = svs.components.analytics;
const services = svs.components.marketplaceCompetition.services.services;
const competitionHandler = svs.components.marketplaceCompetition.competitionHandler.competitionHandler;
const resolveCompetitionName = svs.components.marketplaceCompetition.helpers.resolveCompetitionName;
const SignupError = svs.components.payment.common.error.SignupError;
const _svs$components$marke = svs.components.marketplaceCompetition.constants,
  SignupType = _svs$components$marke.SignupType,
  ScopeType = _svs$components$marke.ScopeType;
const isWager = svs.components.payment.createWager.utils.isWager;
const getValidCompetition = (compHandler, wager) => {
  for (let i = 0; i < wager.bets.length; i++) {
    const bet = wager.bets[i];
    const board = bet.boards[0];
    const competition = compHandler.getActiveCompetition(bet.productId);
    if (competition && bet.systemSize === competition.getSystemSize() && board.systemType === competition.getSystemType()) {
      return {
        competition,
        bet
      };
    }
  }
  return {};
};

const getPlayerCompetitionDetails = async compHandler => {
  const _compHandler$getPlaye = compHandler.getPlayerCompetitionDetails(),
    playerCompetitionDraws = _compHandler$getPlaye.playerCompetitionDraws,
    playerCompetitions = _compHandler$getPlaye.playerCompetitions,
    status = _compHandler$getPlaye.status;

  if (!status) {
    logger.info('Details not fetched serverside so fetching client side');
    const result = await compHandler.fetchPlayerCompetitionDetails(undefined, true, true);
    logger.debug('>>', result);
    return [result[1] || {}, result[0] || {}];
  }
  return [playerCompetitionDraws, playerCompetitions];
};

const findPlayableCompetition = async payableItems => {
  const compHandler = competitionHandler();
  if (!compHandler.getActiveCompetitions().length) {
    logger.info('No active competitions found');
    return {};
  }
  let playerCompetitionDraws;
  let playerCompetitions;
  for (let i = 0; i < payableItems.length; i++) {
    const wager = payableItems[i];
    if (!isWager(wager)) {
      continue;
    }
    const productBet = wager.getProductBet;
    if (!productBet || productBet.isOwnRows || productBet.numberOfDraws > 1) {
      continue;
    }

    const _getValidCompetition = getValidCompetition(compHandler, wager),
      competition = _getValidCompetition.competition,
      bet = _getValidCompetition.bet;

    if (competition !== null && competition !== void 0 && competition.isFinished()) {
      break;
    }
    if (competition) {
      var _competition$getData, _playerCompetitionDra;
      const wagerDrawNumber = productBet.drawNumber;
      const currentDrawNumber = competition.getCurrentDrawNumber();
      const drawNumberList = ((_competition$getData = competition.getData()) === null || _competition$getData === void 0 || (_competition$getData = _competition$getData.details) === null || _competition$getData === void 0 ? void 0 : _competition$getData.drawNumberList) || [currentDrawNumber];
      const competitionId = competition === null || competition === void 0 ? void 0 : competition.getCompetitionId();

      var _await$getPlayerCompe = await getPlayerCompetitionDetails(compHandler);
      var _await$getPlayerCompe2 = _slicedToArray(_await$getPlayerCompe, 2);
      playerCompetitionDraws = _await$getPlayerCompe2[0];
      playerCompetitions = _await$getPlayerCompe2[1];
      if (!drawNumberList.includes(wagerDrawNumber)) {
        break;
      }

      if ((_playerCompetitionDra = playerCompetitionDraws[competitionId]) !== null && _playerCompetitionDra !== void 0 && _playerCompetitionDra.find(drawNumber => drawNumber === wagerDrawNumber)) {
        break;
      }
      const isParticipating = Boolean(playerCompetitions[competitionId]);
      const isFirstDraw = currentDrawNumber === competition.getFirstDrawNumber();
      const isPlayable = competition.isPlayable(isParticipating);
      if (isPlayable) {
        return {
          bet,
          competition,
          isFirstDraw,
          isParticipating,
          wager
        };
      }
    }
  }
  return {};
};
const competition = onInteraction => _ref => {
  let paymentInfo = _ref.paymentInfo,
    payment = _ref.payment;
  return async next => {
    logger.info('Running competition middleware');
    const response = await findPlayableCompetition(payment.getPayableItems());
    if (response.competition) {
      try {
        logger.info('Wager matches competition, showing competition dialog.');
        const _await$onInteraction = await onInteraction(response),
          bet = _await$onInteraction.bet,
          competition = _await$onInteraction.competition,
          wager = _await$onInteraction.wager;
        logger.info('User accepted to participate in competition with bet');
        const competitionId = competition.getCompetitionId();
        const compName = resolveCompetitionName(competition.getData());

        paymentInfo.add({
          message: "Ditt spel kommer att delta i ".concat(compName, "."),
          localId: wager.localId,
          type: constants.paymentInfoType.PRE
        });
        paymentInfo.add({
          localId: wager.localId,
          type: constants.paymentInfoType.POST,
          extraData: {
            isCompetitionSignUp: !response.isParticipating,
            compName
          }
        });
        payment.tasks.add(wager.localId, () => new Promise((resolve, reject) => {
          if (!response.isParticipating) {
            services.putParticipation(competitionId, {
              signupType: SignupType.PARTICIPATE,
              scopeType: ScopeType.INDIVIDUAL_ONLY,
              locationId: 0
            }).then(() => {
              logger.info("Anm\xE4lan till ".concat(compName, " \xE4r genomf\xF6rd"), response);
              const isCompetitionSignUp = true;
              wager.addCompetitionForBet(competitionId, bet, isCompetitionSignUp);
              analytics.trackEvent({
                category: competition.getCompType(),
                action: 'joined team',
                opt_label: 'Individuellt'
              });
              return resolve();
            }).catch(err => {
              const error = err.responseJSON.error;
              logger.error("Anm\xE4lan till ".concat(compName, " gick inte att genomf\xF6ra"), error);
              reject(new SignupError({
                clientCode: SignupError.ClientErrorCodes.COMPETITION_ERROR,
                code: error.code,
                extraData: {
                  message: "SignupError - code: ".concat(error.code, ", message: ").concat(error.message)
                },
                message: "Anm\xE4lan till ".concat(compName, " gick inte att genomf\xF6ra")
              }));
            });
          } else {
            const isCompetitionSignUp = false;
            wager.addCompetitionForBet(competitionId, bet, isCompetitionSignUp);
            resolve();
          }
        }));
      } catch (err) {
        logger.info('User declined to participate in competition');
      }
    }
    next();
  };
};
setGlobal('svs.components.payment.middleware.competition', competition);

 })(window);